export class ForgotPasswordRequest {

    public userName!: string;

}
